import * as t from 'io-ts';
import { BookingModificationRequestDynamicType } from './bookingModificationRequest';

export const ModificationRequestsListDynamicType = t.interface({
    bookingId: t.string,
    modificationRequests: t.array(BookingModificationRequestDynamicType)
});

export type ModificationRequestsList = t.TypeOf<typeof ModificationRequestsListDynamicType>;
